/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';
import { Link } from 'react-router-dom';

import styles from './HelpButton.style';

import LazyFAQMain from './LazyFAQMain';
import useRoutes from 'src/shared/app/base/route/hook/useRoutes';
import { faqRoute } from 'src/shared/app/base/route/setting/routeSettings';
import messages from 'src/shared/app/faq/l10n/faqL10n';
import HelpIcon from 'src/shared/ui/component/icon/HelpIcon';

type Props = {
  handleClick: () => void,
};

const useStyles = createUseStyles(styles);

const HelpButtonDumb = ({ handleClick }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();
  const [faqPath] = useRoutes(faqRoute);

  /*
   |----------------------------------------------------------------------------
   | Effects
   |----------------------------------------------------------------------------
   */

  React.useEffect(() => {
    LazyFAQMain.preload();
  }, []);

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <Link to={faqPath} onClick={handleClick} className={classes.root}>
      <div className={classes.icon}>
        <HelpIcon />
      </div>{' '}
      {intl.formatMessage(messages.helpButton)}
    </Link>
  );
};

export default compose(React.memo)(HelpButtonDumb);
